import { ButtonGroup } from 'primereact/buttongroup';
import { Button } from 'primereact/button';
import { ChevronUp } from '@primeicons/react/chevron-up';
import { ChevronDown } from '@primeicons/react/chevron-down';
import styles from '../../cards.module.scss';

function CircumstanceItem({ circumstance, handleClickCircumstance, handleDeleteCircumstance, onChange, layout, currentOrder }) {
  // Fonction pour monter ordre
  const handleMoveUp = (e) => {
    e.stopPropagation();
    onChange(circumstance, -1);
  };

  // Fonction pour descendre ordre
  const handleMoveDown = (e) => {
    e.stopPropagation();
    onChange(circumstance, 1);
  };

  return (
    <div
      className={`${styles.projectCard} ${layout === 'grid' ? styles.projectCardGrid : ''}`}
      onClick={handleClickCircumstance}>
      <div className={styles.projectImageContainer}>
        <img className={styles.projectImage} src={circumstance.images[0].file} alt={circumstance.images[0].title} />
        {circumstance.images.length > 1 &&
          <div className={styles.otherImagesIndicator}>
            <p>+{circumstance.images.length - 1}</p>
          </div>
        }
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{circumstance.title}</p>
          <span className={styles.subtitle}>{circumstance.description}</span>
        </div>
      </div>
      <ButtonGroup className={styles.buttonList}>
        <Button
          variant="outlined"
          severity="primary"
          text
          raised
          iconOnly
          className="rounded-full"
          onClick={handleMoveUp}>
          <ChevronUp />
        </Button>
        {currentOrder && <p>{currentOrder + 1}</p>}
        <Button
          variant="outlined"
          severity="primary"
          iconOnly
          text
          raised
          className="rounded-full"
          onClick={handleMoveDown}>
          <ChevronDown />
        </Button>
      </ButtonGroup>
      <ButtonGroup className={styles.buttonList}>
        <Button
          rounded
          icon="pi pi-trash"
          severity="danger"
          onClick={handleDeleteCircumstance}
          outlined
          size="small"
          className="!h-9 !w-9"
        />
      </ButtonGroup>
    </div>

  );
}

export default CircumstanceItem;
